import { QUERY_KEYS } from 'api/query-keys';
import { projectService } from 'ogp/services';
import { useQuery } from 'react-query';

export const useGetProjectWorkers = () => {
  const queryFn = async () => await projectService.getProjectWorkers();

  return useQuery(QUERY_KEYS.projectWorkers(), queryFn);
};
